import type { StudentAttendanceRow } from "@/types/tables";

export const buildStudentAttendanceRows = (data: any[]): StudentAttendanceRow[] => {
  const rows: StudentAttendanceRow[] = [];

  for (const r of data) {
    for (const s of r.sessions) {
      rows.push({
        rotationId: r._id,
        rotationDate: r.date,
        sessionId: s._id,
        sessionName: s.name,
        present: s.present === 1 ? true : false,
      });
    }
  }

  return rows;
};
